<template>
    <div>
      <div class="container is-fluid">
        
        <div class="level">
          <div class="level-left">
            </div>
         
        </div>
        <div class="box " style="display:none">	
      
          

        
          

          <div class="field ">
            <label class="label">Search Name, Email, or Company</label>
              <div class="control">
                <input class="input" type="text" placeholder="Enter a name" v-model="search"  autofocus v-on:keyup.enter="getContacts()">
              </div>
          </div>

          <div class="field " v-if="1===2">
            <label class="label">Type of Contact</label>
              <div class="control columns">
                <div class="column">
                  <label class="checkbox">
                    <input type="checkbox">
                    General
                  </label>
                </div>
                <div class="column">
                  <label class="checkbox">
                    <input type="checkbox">
                    Applicant
                  </label>
                </div>
                <div class="column">
                  <label class="checkbox">
                    <input type="checkbox">
                    Business
                  </label>
                </div>
                <div class="column">
                  <label class="checkbox">
                    <input type="checkbox">
                    Volunteer
                  </label>
                </div>
              </div>
          </div>

          <div class="field " v-if="1===2">
            <label class="label">Donations</label>
              <div class="select">
                  <select>
                    <option>Select Criteria</option>
                    <option>No donations</option>
                    <option>This Year</option>
                    <option>Ever</option>
                  </select>
                </div>
          </div>

          <div class="field " v-if="1===2">
            <label class="label">Previous Volunteering</label>
              <div class="control columns">
                <div class="column">
                  <label class="checkbox">
                    <input type="checkbox">
                    None
                  </label>
                </div>
                <div class="column">
                  <label class="checkbox">
                    <input type="checkbox">
                    During Past Year
                  </label>
                </div>
                <div class="column">
                  <label class="checkbox">
                    <input type="checkbox">
                    Ever
                  </label>
                </div>
                
              </div>
          </div>

          <div class="field " >
            <label class="label">Applicant In Previous Round</label>
              <div class="select ">
                  <select v-model="round_id">
                    <option value="">Select Round</option>
                   <option v-for="row in rounds" :key="row.id" :value="row.id">{{ row.name }}</option>
                    
                  </select>
                </div>
          </div>

          <div class="field is-grouped">
            <p class="control">
              
              <a class="button is-success" @click.prevent="getContacts()">
                Search
              </a>
              
            </p>
          
          </div>
          
        </div>

        
          
        
      </div>
      <br />
      <ListContacts :contacts="contacts" :loading="loading"></ListContacts>
      <br />
      <div class="container is-fluid" v-if="1===2"> 
          <div class="box">
              <div class="buttons">
                  <router-link to="/people/email"><div class="button is-info">Email All</div></router-link>
                </div>
            </div>
        </div>
  </div>
</template>

<script>


import ContactService from '@/services/ContactService.js';
import UtilityService from '@/services/UtilityService.js';
import ListContacts from '@/components/Contacts/ListContacts';

export default {
  name:"SearchContacts",
  components: {
   	ListContacts
  },
  data() {
    return {
      errors: [],
      contacts: [],
      search: window.localStorage.getItem('search') || "",
      accessToken:'',
      rounds: [],
      round_id:'',
      loading: true
    }
  },
  

  // Fetches posts when the component is created.
  created() {
    this.getAccessToken()
    .then(() => { 
        this.getContacts()
        this.getRounds();
    });
    
    
  },
  methods: {
  	
   async getContacts() {
			this.loading=true
			//localStorage.setItem('search', this.search);
			ContactService.getContacts(this.accessToken, this.search, this.round_id)
			.then(
				(contacts => {
				this.$set(this, "contacts", contacts);
        this.loading=false
				}).bind(this)
        
			);
    },
     getRounds()
    {
      UtilityService.getSimpleApiData(this.accessToken, "rounds").then(
        response => this.rounds = response 
			);
    }
  },
 // beforeRouteLeave (to, from, next) {
  //    
  //      next()
  //}
}

</script>

<style>
	
</style>
